import React, { useState, useEffect } from 'react'
import UserWrapperComponent from "../../../General/UserWrapperComponent"
import ViewReportComponent from "./ViewReportComponent"
import { getReportById } from "../ReportServices"
import { START_LOADING, STOP_LOADING } from "../../../../Utils/Constants";
import { GlobalDispatchContext } from "../../../../Context/Context"

const ViewOpinion = (props) => {

    const [opinion, setOpinion] = useState(null)
    const dispatch = React.useContext(GlobalDispatchContext)
    const getOpinion = () => {

        dispatch({
            type: START_LOADING
        })
        getReportById({
            "reportOpinionID": props.history.location.state ? props.history.location.state.reportOpinionID : -1
        }).then(res => {
            if (res.data.success) {
                dispatch({
                    type: STOP_LOADING
                })
                setOpinion(res.data.data)

            }
        }).catch(er => {
            dispatch({
                type: STOP_LOADING
            })
            console.log(er)
        })
    }
    useEffect(() => {
        getOpinion();
    }, [props.history.location.state])
    return (<>
        {opinion &&
            <ViewReportComponent
                opinion={opinion}
            />}
    </>)
}
const ViewReportContainer = UserWrapperComponent(ViewOpinion)
export default ViewReportContainer